﻿import mixin from './mixin';

import EventFilter from './components/EventFilter.vue';

const axios = require('axios');

const eventOverviewApp = {
	mixins: [mixin],
	components: { EventFilter },
	data() {
		return {
			dataApi: '',
			dataLimit: 8,
			dataGuid: '',
			dataLanguage: '',
			dataJson: null,
			dataIsDetail: false,
			dataParentkey: '',
			dataCurrentkey: '',

			loading: false,
			data: null,
			page: 0,
			initialLoad: true,
			isTabType: true,

			filterTypes: [],
			filterGroups: [],
			filterRegions: [],
			filterOrganizers: [],

			showModal: false,

			dataTypeslabel: '',
			dataGroupslabel: '',
			dataRegionslabel: '',
			dataOrganizerslabel: '',

			dataSortinglabel: 'Sortering',
			dataStandardlabel: 'standaard',
			dataIncreasinglabel: 'titel (A-Z)',
			dataDecreasinglabel: 'titel (Z-A)',
			dataDateIncreasinglabel: 'datum (nieuwste)',
			dataDateDecreasinglabel: 'datum (oudste)',
			sorting: 'standaard',
		};
	},
	computed: {
		itemsSet() {
			return this.data && this.data.items && this.data.items.length;
		},
		offset() {
			return this.initialLoad ? 0 : this.dataLimit * this.page;
		},
		computedLimit() {
			return this.dataLimit + this.dataLimit * this.page;
		},
		queryParams() {
			const urlParams = new URLSearchParams();
			urlParams.set('parentNodeId', this.dataGuid);
			urlParams.set('cultureCode', this.dataLanguage);
			return urlParams.toString();
		},
		filteredItems() {
			if (!this.itemsSet) return [];
			let filteredItems = [...this.data.items];
			filteredItems = filteredItems.filter((item) => this.filterOnDate(item));
			if (this.filterTypes.length) filteredItems = filteredItems.filter((item) => this.filterOnType(item));
			if (this.filterGroups.length) filteredItems = filteredItems.filter((item) => this.filterOnGroup(item));
			if (this.filterRegions.length) filteredItems = filteredItems.filter((item) => this.filterOnRegion(item));
			if (this.filterOrganizers.length) filteredItems = filteredItems.filter((item) => this.filterOnOrganizer(item));
			if (!this.isTabType) filteredItems = filteredItems.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
			
			return filteredItems;
		},
		filteredDetailItems() {
			if (!this.itemsSet) return [];
			let filteredItems = [...this.data.items];
			filteredItems = filteredItems.filter((item) => this.filterOnDate(item));
			if (this.parentKey) filteredItems = filteredItems.filter((item) => item.parentId === this.parentKey);
			filteredItems = filteredItems.filter((item) => item.id !== this.dataCurrentkey);
			filteredItems = filteredItems.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
			return filteredItems;
		},
		limitedItems() {
			if (!this.itemsSet) return [];
			return this.filteredItems.slice(0, this.computedLimit);
		},
		sortedItems() {
			switch (this.sorting) {
				case this.dataStandardlabel:
					return this.limitedItems;
				case this.dataIncreasinglabel:
					return [...this.limitedItems].sort((a, b) => b.name.localeCompare(a.name));
				case this.dataDecreasinglabel:
					return [...this.limitedItems].sort((a, b) => a.name.localeCompare(b.name));
				case this.dataDateIncreasinglabel:
					return [...this.limitedItems].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
				case this.dataDateDecreasinglabel:
					return [...this.limitedItems].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
				default:
					return this.limitedItems;
			}
		},
		types() {
			if (!this.dataJson || !this.dataJson.Aanbodtypes || !this.itemsSet) return [];
			return this.dataJson.Aanbodtypes.filter(type => this.data.items.some(item => item.aanbodtype.includes(type.Naam)));
		},
		groups() {
			if (!this.dataJson || !this.dataJson.Doelgroepen || !this.itemsSet) return [];
			return this.dataJson.Doelgroepen.filter(doelgroep => { 
				return this.data.items.some(item => item.doelgroep.includes(doelgroep.Naam)) ||
				doelgroep.Subdoelgroepen.some(subdoelgroep => this.data.items.some(item => item.doelgroep.includes(subdoelgroep.Naam)))
			});
		},
		regions() {
			if (!this.dataJson || !this.dataJson.Regios || !this.itemsSet) return [];
			return this.dataJson.Regios.filter(regio => this.data.items.some(item => item.regions.includes(regio.Naam)));
		},
		organizers() {
			if (!this.dataJson || !this.dataJson.Organisatoren || !this.itemsSet) return [];
			return this.dataJson.Organisatoren.filter(organisatie => this.data.items.some(item => item.organisator.includes(organisatie.Naam)));
		},
		parentKey() {
			if (!this.dataCurrentkey || !this.dataParentkey || !this.itemsSet) return '';
			let currentItem = this.data.items.find((item) => item.id === this.dataCurrentkey);
			return !currentItem.date || currentItem.date === '0001-01-01T00:00:00' ? this.dataCurrentkey : this.dataParentkey;
		},
		sortingOptions() {
			const options = [
				this.dataStandardlabel,
				this.dataDecreasinglabel,
				this.dataIncreasinglabel,
			];
			if (!this.isTabType) {
                options.push(this.dataDateDecreasinglabel);
                options.push(this.dataDateIncreasinglabel);
            }
			return options;
		},
	},
	methods: {
		async init() {
			this.loading = true;

			if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
			if (this.$el.dataset.guid) this.dataGuid = this.$el.dataset.guid;
			if (this.$el.dataset.language) this.dataLanguage = this.$el.dataset.language;
			if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
			if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);
			if (this.$el.dataset.isdetail) this.dataIsDetail = true;
			if (this.$el.dataset.parentkey) this.dataParentkey = this.$el.dataset.parentkey;
			if (this.$el.dataset.currentkey) this.dataCurrentkey = this.$el.dataset.currentkey;

			if (this.dataIsDetail) this.isTabType = false;

			if (this.$el.dataset.typeslabel) this.dataTypeslabel = this.$el.dataset.typeslabel;
			if (this.$el.dataset.groupslabel) this.dataGroupslabel = this.$el.dataset.groupslabel;
			if (this.$el.dataset.regionslabel) this.dataRegionslabel = this.$el.dataset.regionslabel;
			if (this.$el.dataset.organizerslabel) this.dataOrganizerslabel = this.$el.dataset.organizerslabel;

			if (this.$el.dataset.sortinglabel) this.dataSortinglabel = this.$el.dataset.sortinglabel;
			if (this.$el.dataset.standardlabel) this.dataStandardlabel = this.$el.dataset.standardlabel;
			if (this.$el.dataset.increasinglabel) this.dataIncreasinglabel = this.$el.dataset.increasinglabel;
			if (this.$el.dataset.decreasinglabel) this.dataDecreasinglabel = this.$el.dataset.decreasinglabel;
			if (this.$el.dataset.dateincreasinglabel) this.dataDateIncreasinglabel = this.$el.dataset.dateincreasinglabel;
			if (this.$el.dataset.datedecreasinglabel) this.dataDateDecreasinglabel = this.$el.dataset.datedecreasinglabel;

			const response = await this.fetchData();
			if (response && response.data) this.data = response.data;
			this.loading = false;
		},
		async fetchData() {
			try {
				const response = await axios.get(`${this.dataApi}?${this.queryParams}`);
				return response;
			} catch (error) {
				console.log(error);
			}
		},
		loadMore() {
			this.page++;
			this.updateUrl();
		},
		updateUrl() {
			const urlParams = new URLSearchParams();
			this.page ? urlParams.append('page', this.page) : urlParams.delete('page');
			this.filterTypes.length ? urlParams.append('types', this.filterTypes.join('+')) : urlParams.delete('types');
			this.filterGroups.length ? urlParams.append('groups', this.filterGroups.join('+')) : urlParams.delete('groups');
			this.filterRegions.length ? urlParams.append('regions', this.filterRegions.join('+')) : urlParams.delete('regions');
			this.filterOrganizers.length ? urlParams.append('organizers', this.filterOrganizers.join('+')) : urlParams.delete('organizers');
			this.isTabType === false ? urlParams.append('tab', 'date') : urlParams.delete('tab');
			history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
		},
		filterOnType(item) {
			return this.filterTypes.some(type => item.aanbodtype.includes(type))
		},
		filterOnGroup(item) {
			return this.filterGroups.some(group => item.doelgroep.includes(group))
		},
		filterOnRegion(item) {
			return this.filterRegions.some(region => item.regions.includes(region))
		},
		filterOnOrganizer(item) {
			return this.filterOrganizers.some(organisator => item.organisator.includes(organisator))
		},
		filterOnDate(item) {
			if (this.isTabType) return !item.date || new Date(item.date).getFullYear() === 1;
			const startOfDay = new Date(new Date().setHours(0, 0, 0, 0));
			if (item.dateEnd && new Date(item.dateEnd).getFullYear() !== 1) {
				return new Date(item.dateEnd).getTime() > startOfDay.getTime();
			}
			return new Date(item.date).getTime() > startOfDay.getTime();
		},
		onFilterType(typeName) {
			const index = this.filterTypes.indexOf(typeName);
			if (index > -1) {
				this.filterTypes.splice(index, 1);
			} else {
				this.filterTypes.push(typeName);
			}
			this.page = 0;
			this.updateUrl();
		},
		onFilterGroup(groupName) {
			const newFilterGroups = [...this.filterGroups];
			const index = newFilterGroups.indexOf(groupName);
			if (index > -1) {
				newFilterGroups.splice(index, 1);
				const topGroup = this.groups.find((g) => g.Naam === groupName);
				if (topGroup) {
					topGroup.Subdoelgroepen.forEach((subGroup) => {
						const subIndex = newFilterGroups.indexOf(subGroup.Naam);
						if (subIndex > -1) {
							newFilterGroups.splice(subIndex, 1);
						}
					});
				}
			} else {
				newFilterGroups.push(groupName);
				const topGroup = this.groups.find((g) => g.Naam === groupName);
				if (topGroup) {
					topGroup.Subdoelgroepen.forEach((subGroup) => {
						if (!newFilterGroups.includes(subGroup.Naam)) {
							newFilterGroups.push(subGroup.Naam);
						}
					});
				}
			}
			this.filterGroups = newFilterGroups;
			this.page = 0;
			this.updateUrl();
		},
		onFilterRegion(regionName) {
			const index = this.filterRegions.indexOf(regionName);
			if (index > -1) {
				this.filterRegions.splice(index, 1);
			} else {
				this.filterRegions.push(regionName);
			}
			this.page = 0;
			this.updateUrl();
		},
		onFilterOrganizer(organizerName) {
			const index = this.filterOrganizers.indexOf(organizerName);
			if (index > -1) {
				this.filterOrganizers.splice(index, 1);
			} else {
				this.filterOrganizers.push(organizerName);
			}
			this.page = 0;
			this.updateUrl();
		},
		onClickTab(isTabType) {
			this.isTabType = isTabType;
			if (this.isTabType && (this.sorting === this.dataDateIncreasinglabel || this.sorting === this.dataDateDecreasinglabel)) this.setSorting(this.dataStandardlabel);
			this.page = 0;
			this.updateUrl();
		},
		hasDifferentDates(item) {
			if (!item || !item.date || !item.dateEnd) return false;
			if (
				!new Date(item.dateEnd).getFullYear() ||
				new Date(item.dateEnd).getFullYear() === 1
			)
				return false;
			if (this.toDateStr(item.date) === this.toDateStr(item.dateEnd))
				return false;
			return true;
		},
		showTime(dateString) {
			if (!dateString) return false;
			const date = new Date(dateString);
			if (date.getHours() === 0) return false;
			if (!date.getFullYear() || date.getFullYear() === 1) {
				const timePart = dateString.split('T')[1];
				const [hour, minute] = timePart.split(':');
				if (hour === '00' && minute === '00') return false;
			}
			return true;
		},
		openModal() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		openDropdown(ref) {
			if (this.$refs[ref]) {
				this.$refs[ref].classList.add('is-active');

				document.addEventListener('click', (event) => {
					if (!this.$refs[ref].contains(event.target)) {
						this.$refs[ref].classList.remove('is-active');
					}
				});
			}
		},
		setSorting(sorting, ref) {
			if (this.$refs[ref]) {
				this.$refs[ref].classList.remove('is-active');
			}
			this.sorting = sorting;
			const url = new URL(location);
			url.searchParams.set('sorting', this.sorting);
			if (this.sorting === 'standaard') url.searchParams.delete('sorting');
			history.pushState({}, '', url);
		},
	},
	created() {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('page')) this.page = parseInt(urlParams.get('page'));
		if (urlParams.has('types')) this.filterTypes = urlParams.get('types').split('+');
		if (urlParams.has('groups')) this.filterGroups = urlParams.get('groups').split('+');
		if (urlParams.has('regions')) this.filterRegions = urlParams.get('regions').split('+');
		if (urlParams.has('organizers')) this.filterOrganizers = urlParams.get('organizers').split('+');
		if (urlParams.has('tab')) this.isTabType = false;
		if (urlParams.has('sorting')) this.sorting = urlParams.get('sorting');
	},
	mounted() {
		this.init();
	},
};

export default eventOverviewApp;
